import React from "react";
import "./CertificateGroupingGWPGeneral.scss";
import CertificateGroupingListGWPGeneralFinalReview from "../../features/CertificateGroupingListGWPGeneralFinalReview/CertificateGroupingListGWPGeneralFinalReview";


const CertificateGroupingGWPGeneralForFinalReviewPage = () => {
  return (
    <div className="analytics-page">
      <CertificateGroupingListGWPGeneralFinalReview />
    </div>
  );
};

export default CertificateGroupingGWPGeneralForFinalReviewPage;